/* Lorelia · Produktseite 9 (28.09.2026) – Poster + Fotoprodukte, Seitenzustand vor dem Gestalter.
   - Abschnitte erscheinen ruhig beim Scrollen (einmalig, IntersectionObserver). Erst dieses Skript setzt
     html.lr-pdp9-js – ohne Skript ist alles sichtbar.
   - Klebeleiste (.lr-klebe aus lr-gestalter8.js) erst zeigen, wenn der Startknopf aus dem Bild ist.
   - Vorlagen-Kacheln (data-p9-vorlage): Vorlage im teeinblue-Formular wählen; das Öffnen erledigt
     lr-gestalter8.js über data-lr-auf. teeinblue-DOM wird nie verändert, nur das Label angeklickt.
   - Platzhalter-Knopf: wird getippt, bevor teeinblue bereit ist, merkt er sich den Wunsch und öffnet danach. */
(function () {
  'use strict';
  var D = document, H = D.documentElement;
  var RUHIG = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  H.classList.add('lr-pdp9-js');

  /* ---------- Überschriften: Wörter steigen aus einer Maske ---------- */
  function worte(el) {
    if (el.getAttribute('data-p9-fertig')) return;
    el.setAttribute('data-p9-fertig', '1');
    if (RUHIG) return;
    var text = el.textContent.trim(); if (!text) return;
    el.setAttribute('aria-label', text);
    var frag = D.createDocumentFragment();
    text.split(/\s+/).forEach(function (w, i) {
      var a = D.createElement('span'); a.className = 'p9-w'; a.setAttribute('aria-hidden', 'true');
      var b = D.createElement('span'); b.textContent = w; b.style.setProperty('--w', i);
      a.appendChild(b); frag.appendChild(a); frag.appendChild(D.createTextNode(' '));
    });
    el.textContent = ''; el.appendChild(frag);
  }
  [].forEach.call(D.querySelectorAll('[data-p9-worte]'), worte);

  /* ---------- Einblenden ---------- */
  var ziele = [].slice.call(D.querySelectorAll('[data-p9-auf], .lr-pdp9-szene, .lr-pdp9-akk'));
  if (!('IntersectionObserver' in window) || RUHIG) {
    ziele.forEach(function (e) { e.classList.add('is-da'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-da'); io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    ziele.forEach(function (e) {
      /* Was beim Laden schon im Bild ist, sofort zeigen (kein Aufblitzen) */
      var r = e.getBoundingClientRect();
      if (r.top < innerHeight * 0.9 && r.bottom > 0) e.classList.add('is-da'); else io.observe(e);
    });
  }

  /* ---------- Klebeleiste: erst zeigen, wenn ein Startknopf nach oben aus dem Bild gescrollt ist,
     und wieder ausblenden, solange irgendein Startknopf (oben oder unten im Fuß) zu sehen ist.
     So sieht der Kunde zuerst Bilder, Preis und Infos (02.10.2026). */
  var sichtbar = {}, vorbei = {};
  var klebeIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var k = e.target.getAttribute('data-p9-id');
      if (!e.boundingClientRect.height) { delete sichtbar[k]; delete vorbei[k]; return; }   /* ausgeblendeter Platzhalter zählt nicht */
      sichtbar[k] = e.isIntersecting;
      vorbei[k] = !e.isIntersecting && e.boundingClientRect.bottom <= 0;                     /* nach oben weggescrollt */
    });
    var ks = Object.keys(sichtbar); if (!ks.length) return;
    var einer = ks.some(function (k) { return sichtbar[k]; }), weg = ks.some(function (k) { return vorbei[k]; });
    D.body.classList.toggle('lr-pdp9-klebe', !einer && weg);
  }, { threshold: 0 }) : null;
  var nr = 0;
  function beobachteKnoepfe() {
    if (!klebeIO) { D.body.classList.add('lr-pdp9-klebe'); return; }
    [].forEach.call(D.querySelectorAll('.lr-start [data-lr-auf], .lr-pdp9-platz [data-lr-auf], .lr-pdp9-fuss [data-lr-auf]'), function (b) {
      if (b.getAttribute('data-p9-id')) return;
      b.setAttribute('data-p9-id', 'k' + (++nr)); klebeIO.observe(b);
    });
  }
  beobachteKnoepfe();
  /* .lr-start entsteht erst, wenn teeinblue bereit ist – kurz nachsehen, ohne Dauer-Timer */
  /* Preis „ab …“: bleibt die Preisabfrage von lr-gestalter8.js aus, gilt der Preis aus Liquid
     (lr-gestalter8.js überschreibt ihn, sobald sein eigener Wert da ist) */
  var kopf = D.querySelector('[data-p9-ab]'), abText = kopf && kopf.getAttribute('data-p9-ab');
  function preisFuellen() {
    var offen = false;
    [].forEach.call(D.querySelectorAll('[data-lr-ab]'), function (e) {
      if (abText && e.textContent.indexOf('…') > -1) { e.textContent = abText; }
    });
    return offen;
  }
  var versuche = 0;
  (function warte() {
    beobachteKnoepfe(); preisFuellen();
    if ((D.querySelector('.lr-start') && versuche > 12) || ++versuche > 45) return;
    setTimeout(warte, 350);
  })();
  /* Beim Scrollen in .page-wrapper feuert IO zuverlässig; nach dem Schließen des Gestalters neu prüfen */
  var warOffen = D.body.classList.contains('lr-gestalten');
  new MutationObserver(function () {
    var offen = D.body.classList.contains('lr-gestalten');
    if (offen === warOffen) return;
    warOffen = offen;
    if (!offen && klebeIO) setTimeout(function () {
      [].forEach.call(D.querySelectorAll('[data-p9-id]'), function (b) { klebeIO.unobserve(b); klebeIO.observe(b); });
    }, 80);
  }).observe(D.body, { attributes: true, attributeFilter: ['class'] });

  /* ---------- Brücke: Chip auf dem Produktbild → „So wirkt es bei dir“ ---------- */
  (function () {
    var sz = D.getElementById('p9-szenen'), m = D.querySelector('.product-information__media');
    if (!sz || !m || m.querySelector('.lr-pdp9-chip')) return;
    var bilder = [].slice.call(sz.querySelectorAll('[data-p9-klein]'), 0, 3);
    if (!bilder.length) return;
    var a = D.createElement('a'); a.className = 'lr-pdp9-chip'; a.href = '#p9-szenen';
    var n = +sz.getAttribute('data-p9-n') || bilder.length;
    a.innerHTML = '<span class="lr-pdp9-chip__bilder">' + bilder.map(function (b) { return '<img alt="" width="32" height="32" loading="lazy" src="' + b.getAttribute('data-p9-klein') + '">'; }).join('') + '</span><span>' + (n > 1 ? n + ' Bilder bei dir zu Hause' : 'So wirkt es bei dir') + '</span><i aria-hidden="true">↓</i>';
    a.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      sz.scrollIntoView({ behavior: RUHIG ? 'auto' : 'smooth', block: 'start' });
    });
    /* Fotogeschenke: eigene Galerie (.lr-gal, wird später gebaut) – Chip auf das große Bild, nicht über die Miniaturen */
    var gross = m.querySelector('.lr-gal-gross');
    (gross || m).appendChild(a);
    if (!gross && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        var g = m.querySelector('.lr-gal-gross');
        if (g) { g.appendChild(a); mo.disconnect(); }
      });
      mo.observe(m, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  })();

  /* ---------- Platzhalter: Tipp vor teeinblue merken ---------- */
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lr-auf]');
    if (!b || D.querySelector('.tee-campaign')) return;
    if (b.getAttribute('data-p9-wartet')) return;
    b.setAttribute('data-p9-wartet', '1');
    var platz = b.closest('.lr-pdp9-platz'); if (platz) platz.classList.add('lr-pdp9-wartet');
    var t = platz ? b.querySelector('span') : null; var alt = t ? t.textContent : '';
    if (t) t.textContent = 'Gestalter lädt …';
    var n = 0;
    function fertig() { b.removeAttribute('data-p9-wartet'); if (t) t.textContent = alt; if (platz) platz.classList.remove('lr-pdp9-wartet'); }
    (function nochmal() {
      if (D.querySelector('.tee-campaign .tee-field')) { fertig(); b.click(); return; }
      if (++n < 40) setTimeout(nochmal, 300); else fertig();
    })();
  });

  /* ---------- Vorlagen-Kacheln: Design wählen, dann öffnet lr-gestalter8.js ---------- */
  function waehleVorlage(id, versuch) {
    var f = D.querySelector('.tee-campaign .tee-field--template');
    var r = f && f.querySelector('input[type="radio"][value="' + id + '"]');
    if (r) {
      if (!r.checked) {
        var l = r.closest('label') || (r.id && f.querySelector('label[for="' + r.id + '"]'));
        (l || r).click();
      }
      return;
    }
    var s = f && f.querySelector('select');
    if (s && [].some.call(s.options, function (o) { return o.value === id; })) {
      if (s.value !== id) { s.value = id; s.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    if ((versuch || 0) < 30) setTimeout(function () { waehleVorlage(id, (versuch || 0) + 1); }, 300);
  }
  /* Werbe-Neustart 16.10.2026: Anzeigen-Link mit ?design=template-… zeigt dieses Design sofort im ersten Bild
     (nicht erst im Gestalter). Mit #gestalten übernimmt das wie bisher lr-gestalter9.js. */
  var dq = (location.search.match(/[?&]design=(template-\d+)/) || [])[1];
  if (dq && location.hash !== '#gestalten') waehleVorlage(dq, -40);
  D.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-p9-vorlage]');
    if (k) waehleVorlage(k.getAttribute('data-p9-vorlage'));
  }, true);
})();
